import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress,
  Container,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  IconButton,
  ButtonGroup,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import {
  collection,
  query,
  orderBy,
  doc,
  updateDoc,
  getDoc,
  onSnapshot,
} from "firebase/firestore";
import { db, auth } from "../api/firebase";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch"; // ← これを追加
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom"; // ← ルーティングライブラリ使用

const GroupReportsAdminAccordion = () => {
  const [reports, setReports] = useState([]);
  const [groupNames, setGroupNames] = useState({});
  const [loading, setLoading] = useState(true);

  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [actionText, setActionText] = useState("");
  const [selectedReportId, setSelectedReportId] = useState(null);

  const [reporterNames, setReporterNames] = useState({});

  const [editTarget, setEditTarget] = useState({ reportId: null, index: null });
  const [editText, setEditText] = useState("");
  const [openEditDialog, setOpenEditDialog] = useState(false);

  const [filter, setFilter] = useState("incomplete"); // "incomplete" or "complete"

  const navigate = useNavigate(); // ← react-router-dom v6以降で使用

  const [expandedReportId, setExpandedReportId] = useState(null);
  const [userContacts, setUserContacts] = useState({}); // { [reportId]: { registrationPhone, registrationEmail } }

  // 🔒 権限チェック
  useEffect(() => {
    const checkAdmin = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/home");
        return;
      }

      const userDoc = await getDoc(doc(db, "users", user.uid));
      const data = userDoc.data();

      if (!data?.isAdmin) {
        navigate("/home");
      }
    };

    checkAdmin();
  }, [navigate]);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      query(collection(db, "groupReports"), orderBy("reportedAt", "desc")),
      (snapshot) => {
        const reportList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setReports(reportList);
      },
      (error) => {
        console.error("リアルタイム取得失敗:", error);
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchMetaInfo = async () => {
      const groupIds = [
        ...new Set(reports.map((r) => r.groupId).filter(Boolean)),
      ];
      const reporterIds = [
        ...new Set(reports.map((r) => r.reportedBy).filter(Boolean)),
      ];

      const groupMap = {};
      await Promise.all(
        groupIds.map(async (id) => {
          const docSnap = await getDoc(doc(db, "groups2025half", id));
          groupMap[id] = docSnap.exists()
            ? docSnap.data().name
            : "不明なグループ";
        })
      );
      setGroupNames(groupMap);

      const reporterMap = {};
      await Promise.all(
        reporterIds.map(async (id) => {
          const docSnap = await getDoc(doc(db, "users", id));
          reporterMap[id] = docSnap.exists()
            ? docSnap.data().name
            : "不明なユーザー";
        })
      );
      setReporterNames(reporterMap);

      setLoading(false);
    };

    if (reports.length > 0) fetchMetaInfo();
  }, [reports]);

  const handleAddHistory = async () => {
    if (!selectedReportId || !actionText.trim()) return;

    try {
      const user = auth.currentUser;
      if (!user) throw new Error("ログインしていません");

      const userDoc = await getDoc(doc(db, "users", user.uid));
      const authorName = userDoc.exists() ? userDoc.data().name : "不明";

      const reportRef = doc(db, "groupReports", selectedReportId);
      const targetReport = reports.find((r) => r.id === selectedReportId);
      const currentHistory = targetReport?.history || [];

      await updateDoc(reportRef, {
        history: [
          ...currentHistory,
          {
            text: actionText.trim(),
            createdAt: new Date(),
            authorName,
          },
        ],
      });

      console.log("✅ 履歴追加完了");
    } catch (err) {
      console.error("❌ 履歴追加失敗:", err);
    } finally {
      setOpenActionDialog(false);
      setActionText("");
    }
  };

  const handleDeleteHistory = async (reportId, indexToDelete) => {
    try {
      const reportRef = doc(db, "groupReports", reportId);
      const report = reports.find((r) => r.id === reportId);
      if (!report || !report.history) return;

      const updatedHistory = [...report.history];
      updatedHistory.splice(indexToDelete, 1);

      await updateDoc(reportRef, { history: updatedHistory });
      console.log("🗑️ 履歴削除完了");
    } catch (err) {
      console.error("❌ 履歴削除失敗:", err);
    }
  };

  const filteredReports = reports.filter((r) =>
    filter === "complete" ? r.finish === true : r.finish !== true
  );

  console.log("report =>", reports);

  //   filteredReports.map((report, index) => (
  //     <Accordion key={report.id}>
  //       <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //         <Typography fontWeight="bold">
  //           {index + 1}. {report.reportedUserName} ←{" "}
  //           {reporterNames[report.reportedBy]} / {groupNames[report.groupId]} /{" "}
  //           {report.reportReason}
  //         </Typography>
  //       </AccordionSummary>
  //       {/* ... */}
  //     </Accordion>
  //   ));

  const handleAccordionChange = async (reportId, userId) => {
    setExpandedReportId((prev) => (prev === reportId ? null : reportId));

    if (!userContacts[reportId]) {
      try {
        const userDoc = await getDoc(doc(db, "users", userId));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserContacts((prev) => ({
            ...prev,
            [reportId]: {
              registrationPhone: data.registrationPhone || null,
              registrationEmail: data.registrationEmail || null,
            },
          }));
        }
      } catch (err) {
        console.error("ユーザー情報の取得エラー:", err);
      }
    }
  };

  if (loading) {
    return (
      <Box mt={4} textAlign="center">
        <CircularProgress />
        <Typography mt={2}>読み込み中...</Typography>
      </Box>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        グループ内通報一覧
      </Typography>

      <Box display="flex" justifyContent="center" mb={3}>
        <ButtonGroup variant="outlined">
          <Button
            onClick={() => setFilter("incomplete")}
            variant={filter === "incomplete" ? "contained" : "outlined"}
            color="primary"
          >
            未完
          </Button>
          <Button
            onClick={() => setFilter("complete")}
            variant={filter === "complete" ? "contained" : "outlined"}
            color="primary"
          >
            完了
          </Button>
        </ButtonGroup>
      </Box>

      {filteredReports.length === 0 ? (
        <Typography color="text.secondary">通報はまだありません。</Typography>
      ) : (
        filteredReports.map((report, index) => (
          <Accordion
            key={report.id}
            onChange={() =>
              handleAccordionChange(report.id, report.reportedUserId)
            }
            sx={{
              mb: 1,
              borderLeft:
                report.history?.length > 0
                  ? "5px solid #4caf50"
                  : "5px solid transparent",
              backgroundColor: report.history?.length > 0 ? "#f0fdf4" : "white", // ← 薄緑 or 通常
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="bold">
                {index + 1}. {report.reportedUserName} ←{" "}
                {reporterNames[report.reportedBy]} /{" "}
                {groupNames[report.groupId]} / {report.reportReason}
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography variant="body2" gutterBottom>
                🕒 通報日時：{" "}
                {report.reportedAt?.toDate
                  ? report.reportedAt.toDate().toLocaleString("ja-JP")
                  : "不明"}
              </Typography>

              <Typography variant="body2">
                👤 対象者：{report.reportedUserName || "不明"}（
                {report.reportedUserId}）
              </Typography>

              {/* ⬇ ここが追加部分 */}
              {userContacts[report.id]?.registrationPhone && (
                <Typography variant="body2">
                  📞 電話番号：{userContacts[report.id].registrationPhone}
                </Typography>
              )}
              {userContacts[report.id]?.registrationEmail && (
                <Typography variant="body2">
                  ✉️ メールアドレス：{userContacts[report.id].registrationEmail}
                </Typography>
              )}

              <Box display="flex" alignItems="center" gap={2} mt={2}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setSelectedReportId(report.id);
                    setOpenActionDialog(true);
                  }}
                >
                  対応履歴を追加
                </Button>

                <FormControlLabel
                  control={
                    <Switch
                      checked={!!report.finish}
                      onChange={async (e) => {
                        try {
                          const reportRef = doc(db, "groupReports", report.id);
                          await updateDoc(reportRef, {
                            finish: e.target.checked,
                          });
                          console.log(
                            `✅ finish を ${e.target.checked} に更新しました`
                          );
                        } catch (err) {
                          console.error("❌ finish 更新エラー:", err);
                        }
                      }}
                    />
                  }
                  label="完了"
                />
              </Box>

              {/* 履歴の表示 */}
              {report.history && report.history.length > 0 && (
                <Box mt={2}>
                  <Typography variant="subtitle2" gutterBottom>
                    対応履歴
                  </Typography>
                  {report.history
                    .slice()
                    .sort(
                      (a, b) =>
                        b.createdAt?.toDate?.() - a.createdAt?.toDate?.()
                    )
                    .map((h, i) => (
                      <Box
                        key={i}
                        sx={{
                          border: "1px solid #ddd",
                          borderRadius: 1,
                          p: 1.5,
                          mb: 1,
                          backgroundColor: "#f9f9f9",
                          position: "relative",
                        }}
                      >
                        <Typography variant="body2" gutterBottom>
                          📝 {h.text}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {h.createdAt?.toDate
                            ? h.createdAt.toDate().toLocaleString("ja-JP")
                            : "日時不明"}{" "}
                          {h.authorName ? `- ${h.authorName}` : ""}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteHistory(report.id, i)}
                          sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => {
                            setEditTarget({ reportId: report.id, index: i });
                            setEditText(h.text);
                            setOpenEditDialog(true);
                          }}
                          sx={{ position: "absolute", top: 4, right: 36 }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
        ))
      )}

      {/* ダイアログ */}
      <Dialog
        open={openActionDialog}
        onClose={() => {
          setOpenActionDialog(false);
          setActionText("");
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>対応履歴を追加</DialogTitle>
        <DialogContent>
          <TextField
            label="対応内容"
            multiline
            fullWidth
            minRows={3}
            value={actionText}
            onChange={(e) => setActionText(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenActionDialog(false);
              setActionText("");
            }}
          >
            キャンセル
          </Button>
          <Button
            onClick={handleAddHistory}
            disabled={!actionText.trim()}
            variant="contained"
          >
            保存
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>対応履歴の編集</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            fullWidth
            minRows={3}
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
            label="対応内容"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)}>キャンセル</Button>
          <Button
            onClick={async () => {
              const { reportId, index } = editTarget;
              if (reportId == null || index == null) return;

              try {
                const reportRef = doc(db, "groupReports", reportId);
                const report = reports.find((r) => r.id === reportId);
                if (!report || !report.history) return;

                const updatedHistory = [...report.history];
                updatedHistory[index] = {
                  ...updatedHistory[index],
                  text: editText.trim(),
                };

                await updateDoc(reportRef, { history: updatedHistory });
                console.log("✏️ 履歴編集完了");
              } catch (err) {
                console.error("❌ 履歴編集エラー:", err);
              } finally {
                setOpenEditDialog(false);
              }
            }}
            disabled={!editText.trim()}
            variant="contained"
          >
            保存
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default GroupReportsAdminAccordion;
